import React from 'react'

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: '', errorInfo: '' }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: JSON.stringify(error),
      errorInfo: JSON.stringify(errorInfo),
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-error={this.state.error}
          data-error-info={this.state.errorInfo}
        ></div>
      )
    }

    return this.props.children
  }
}
